import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {DataService} from '../../data/data.ts';
import { Slides } from 'ionic-angular';
import { ViewChild } from '@angular/core';

import * as firebase from 'firebase';

@Component({
  templateUrl: 'build/pages/background/background.html'
})
export class BackgroundPage {
  private dataService: DataService;
  @ViewChild('mySlider') slider: Slides;
  @ViewChild('mySliderExample') sliderExample: Slides;
  private currentTitle = "Background";
  private prevIndex = -1;
  private nextIndex = 1;
  mySlideOptions = {
    loop: true,
    pager: true
  };

  constructor(private navCtrl: NavController, private _data: DataService) {
  	this.dataService = _data;
  }

  nextSlide() {
    this.slider.slideNext();
  }

  previousSlide() {
    this.slider.slidePrev();
  }

  onSlideChanged() {
  	if (this.slider.getSlider() != undefined){
  		let currentIndex = this.slider.getActiveIndex();
  		this.prevIndex = currentIndex - 1;
	    this.nextIndex = currentIndex + 1;
  		this.setIndexTitles(currentIndex); 
  	}
  }

  setIndexTitles(currentIndex){
  	
    let arrayLength = this.dataService.currentMysteryInformation.length;

    if (currentIndex < arrayLength){
    	this.currentTitle = this.dataService.currentMysteryInformation[currentIndex].title
    }
  }
}
